import React, { useState, useEffect } from 'react';
import { useLayout } from '../../LayoutContext';
import { Input, Label, Table } from 'reactstrap';
import Header from '../../components/header/Header';
import { BasicStyle } from './formsStyle';
import cornerRightArrow from '../../components/assets/corner-right-down.svg';
import Footer from '../../components/footer/Footer';
import Logo from '../../components/assets/sulamerica-pride.svg';
import imageSource from '../../components/assets/dados-basicos-amarelo.webp';
import ProgressBar from '../../components/status/ProgressBar';
import FooterValidation from '../../components/footer/Footer';
import videoSource from '../../components/assets/Video_forms.mp4';

const FormBasic = () => {
  const [progress, setProgress] = useState(5);

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  // Função para alternar a visibilidade
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const plan = sessionStorage.getItem('@plan');

  const planObject = JSON.parse(plan);

  useEffect(() => {
    sessionStorage.setItem('@fullName', JSON.stringify(fullName));
    sessionStorage.setItem('@phone', JSON.stringify(phone));
    sessionStorage.setItem('@cnpj', JSON.stringify(cnpj));
    sessionStorage.setItem('@email', JSON.stringify(email));
    sessionStorage.setItem('@city', JSON.stringify(city));
  }, [fullName, phone, cnpj, email, city]);

  const handleFullName = (e) => {
    setFullName(e.target.value);
  };

  const handlePhone = (e) => {
    let formattedPhone = e.target.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

    // Aplica formatação de acordo com o tamanho do número
    if (formattedPhone.length <= 10) {
      formattedPhone = formattedPhone.replace(
        /^(\d{2})(\d{4})(\d{4})$/,
        '($1) $2-$3',
      ); // (XX) XXXX-XXXX
    } else {
      formattedPhone = formattedPhone.replace(
        /^(\d{2})(\d{5})(\d{4}).*/,
        '($1) $2-$3',
      ); // (XX) XXXXX-XXXX
    }

    setPhone(formattedPhone);
  };

  const handleCnpj = (e) => {
    let formattedCnpj = e.target.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

    // Aplica formatação do CNPJ
    formattedCnpj = formattedCnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/,
      '$1.$2.$3/$4-$5',
    ); // XX.XXX.XXX/0001-XX

    setCnpj(formattedCnpj);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleCity = (e) => {
    setCity(e.target.value);
  };

  return (
    <>
      <BasicStyle>
        <div className="basic__wrapper">
          <div className="container">
            <div className="logo-form">
              <img className="logo" src={Logo} alt="Logo" height={75} />
            </div>

            <div className="content__wrapper">
              <h1 className="title">
                Precisamos das informações de quem está realizando essa cotação.
              </h1>

              <div className="question__wrapper">
                <p className="text" onClick={toggleDropdown}>
                  Por que precisamos desses dados?{' '}
                  <img
                    className={`arrow ${isDropdownOpen ? 'up' : ''}`}
                    src={cornerRightArrow}
                    alt="Saiba mais"
                  />
                </p>

                <p
                  className={`dropdown-content ${isDropdownOpen ? 'open' : ''}`}
                >
                  Para contato direto, esclarecimento de dúvidas e
                  personalização da proposta.
                </p>
              </div>
            </div>

            <div className="inputs__wrapper">
              <div className="input_container">
                <Label htmlFor="fullNameId">Nome completo</Label>
                <Input
                  type="text"
                  name="fullName"
                  id="fullNameId"
                  value={fullName}
                  onChange={handleFullName}
                />
              </div>

              <div className="input_container">
                <Label htmlFor="fullNameId">Cidade</Label>
                <Input
                  type="text"
                  name="city"
                  id="cityId"
                  value={city}
                  onChange={handleCity}
                />
              </div>

              <div className="input_container">
                <Label htmlFor="phoneId">Telefone</Label>
                <Input
                  type="text"
                  name="phone"
                  id="phoneId"
                  value={phone}
                  onChange={handlePhone}
                />
              </div>

              {planObject.plan === 'Empresarial' && (
                <div className="input_container">
                  <Label htmlFor="cnpjId">CNPJ</Label>
                  <Input
                    type="text"
                    name="cnpj"
                    id="cnpjId"
                    value={cnpj}
                    onChange={handleCnpj}
                  />
                </div>
              )}

              <div className="input_container">
                <Label htmlFor="emailId">Email</Label>
                <Input
                  type="email"
                  name="email"
                  id="emailId"
                  value={email}
                  onChange={handleEmail}
                />
              </div>
            </div>
          </div>
          <ProgressBar progress={progress} steps={5} />
        </div>
        <FooterValidation />
      </BasicStyle>
    </>
  );
};

export default FormBasic;
